import dayjs from 'dayjs';

export const initFilters = Vue => {
  Vue.filter('date', function (value, format) {
    if(value) {
      const valueDate = dayjs(new Date(value));
      const valueFormatted = valueDate.format(format);

      return valueFormatted;
    }
  })
}